<div class="white-wrap-admin mb-4">
  <div class="back-link-outer">
    <div class="back-link-outer mb-3 d-flex">
      <a role="button" (click)="goBack()" class="back-link">
        <img alt="back" src="../assets/images/back.svg" /> back
      </a>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-md-12">
      <p class="body-txt-22 mb-4">View Auction Results</p>
    </div>

    <div class="col-12 col-md-12">
      <div class="form-group m-0">
        <div class="mat-field-width">
          <div class="custom-select-option custom-select-wrap">
            <mat-form-field appearance="outline">
              <mat-label>Select Auction To View Its Results</mat-label>
              <mat-select
                [(value)]="auctionId"
                (selectionChange)="onAuctionChange($event.value)"
              >
                <mat-option
                  *ngFor="let auction of auctionsDD"
                  [value]="auction.value"
                  >{{ auction.text }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="grey-well m-0">
        <div class="for-badge mb-2">
          <span class="card-badge badge-dark">{{
            auctionData?.saleType?.publicName
          }}</span>
        </div>
        <h1 class="well-name mb-2">{{ auctionData?.title }}</h1>
        <h3 class="well-des" [innerHTML]="auctionData?.tagline"></h3>
      </div>
    </div>
  </div>
</div>

<div class="page-title-wrap mb-3 mb-md-4">
  <h1 class="hdg m-0">Auction Results</h1>
</div>

<section class="table-search-wrap mb-1 pb-2">
  <div class="d-none d-md-block">
    <div class="row for-desktop-filters">
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-8 pr-0">
            <div class="form-group">
              <search-control
                [placeholder]="'Search'"
                (value)="changeSearchValue($event)"
              >
              </search-control>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-container *ngIf="totalCount === 0; else showTable">
  <div class="empty-state-container empty-pad-2">
    <div class="empty-state-content">
      <img
        alt="empty-state"
        src="../../../../assets/images/empty-state-icon.svg"
      />
      <h3 class="_heading">No Lot Found</h3>
    </div>
  </div>
</ng-container>

<ng-template #showTable>
  <div class="data-table-wrap">
    <app-paginator
      [paginationId]="'server'"
      [currentPage]="pageNumber"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      *ngIf="totalCount > pageSize"
    >
    </app-paginator>

    <table
      aria-label="table"
      mat-table
      [dataSource]="
        lotResults
          | paginate
            : {
                id: 'server',
                itemsPerPage: pageSize,
                currentPage: pageNumber,
                totalItems: totalCount
              }
      "
      class="mat-elevation-z8 custom-data-table resultTable"
    >
      <ng-container matColumnDef="lotDes">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-1 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <div class="withImage">
            <div class="forImageRow">
              <img
                class="location mr-2"
                alt="location"
                LotThumbnail
                [lotNumber]="element.lotNumber"
                [lotImages]="element.thumbnailImages"
              />
              <span class="lotNumberSquare">
                Lot
                <span>#{{ element.lotNumber }}</span>
              </span>
            </div>
            <div class="forDescr">
              <span class="td-header">Lot Description</span>
              {{ element.description }}
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-2 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <span class="td-header withIcon">
            <img
              class="location mr-2"
              alt="location"
              src="../assets/images/location-green.svg"
            />
            Location
          </span>
          {{ element.location }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-3 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <span class="td-header">Quantity</span>{{ element.quantity }}
        </td>
      </ng-container>

      <ng-container matColumnDef="startPrice">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-4 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <span class="td-header">Starting Price</span
          >{{ element.openingPrice | currency: "USD" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="endTime">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-5 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <span class="td-header withIcon">
            <img
              class="location mr-2"
              alt="location"
              src="../assets/images/calender.svg"
            />
            Lot End Time</span
          >{{ element.lotEndTimeUtc | toLocalDateTime }}
        </td>
      </ng-container>

      <ng-container matColumnDef="priceSold">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-6 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <span class="td-header">Price Sold</span
          >{{ element.amount | currency: "USD" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="winningBidder">
        <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
        <td
          mat-cell
          class="column-7 listing-data-entry table-with-row-header"
          *matCellDef="let element"
        >
          <ng-container *ngIf="element.user">
            <span class="td-header">Winning Bidder</span>
            {{
              element.auctionUser?.paddleNumber
                ? "#" + element.auctionUser?.paddleNumber
                : "NA"
            }}
            {{
              ", " + element.user?.firstName + " " + element.user?.lastName ||
                "NA" + element.user?.lastName ||
                ""
            }}
            {{ ", " + (element.user?.companyName | isEmpty: "NA") }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <app-paginator
      [paginationId]="'server'"
      [currentPage]="pageNumber"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      *ngIf="totalCount > pageSize"
    >
    </app-paginator>
  </div>
</ng-template>
